<template>
  <div class="assign-students-dialog">
    <el-dialog title="分配学生" :visible="assignStudentsDialogShow" width="1200px" @close="dialogClose" @open="dialogOpen">
      <el-form @submit.native.prevent :inline="true">
        <el-form-item label="学生搜索" label-width="80px">
          <div class="notice-search">
            <search :placeholder="placeholder" @search="search" />
          </div>
        </el-form-item>
        <el-form-item label="选择班级" label-width="80px">
          <el-cascader class="select" clearable v-model="className" :placeholder="classPlaceholder" :props="classProps"
          :options="classSelect" @change="classSearch"></el-cascader>
        </el-form-item>
      </el-form>
      <div class="table-list">
        <div class="table-item">
          <div>未绑定学生：</div>
          <el-table ref="table" :data="studentList" style="width: 100%" height="350px"
            @selection-change="handleAddSelection">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="studentName" label="姓名" width="180"> </el-table-column>
            <el-table-column prop="studentNumber" label="学号" width="180"> </el-table-column>
            <el-table-column prop="date" label="班级">
              <template slot-scope="scope">
                {{ scope.row.gradeName + scope.row.className }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table-item">
          <div>已绑定学生：{{ assignStudentsData.studentData.length }} 名</div>
          <el-table ref="bindTable" :data="assignStudentsData.studentData" style="width: 100%" height="350px">
            <el-table-column prop="studentName" label="姓名"> </el-table-column>
            <el-table-column prop="studentNumber" label="学号"> </el-table-column>
            <el-table-column prop="date" label="班级">
              <template slot-scope="scope">
                {{ scope.row.gradeName + scope.row.className }}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <div class="handle-container">
                  <!-- 删除 -->
                  <el-button type="danger" icon="el-icon-delete" @click="deleteTeacherStudentLink(scope.row)"
                    size="small">移除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
export default {
  name: "",
  props: ["assignStudentsDialogShow", "assignStudentsData", "studentList", 'classSelect', 'classProps', 'classSelectList', 'classPlaceholder'],
  data() {
    return {
      placeholder: "请输入学生姓名",
      teacherName: "",
      gradeId: "",
      classId: "",
      className: ""
    };
  },
  inject: ['refresh'],
  components: {
    search,
  },
  methods: {
    classSearch(e) {
      if (e.length) {
        this.gradeId = e[0].gradeId;
        this.classId = e[1].classId;
      } else {
        this.gradeId = "";
        this.classId = "";
      };

      this.$emit('classSearch', this.gradeId, this.classId);
    },
    // 删除单个绑定
    deleteTeacherStudentLink(row) {
      let data = {
        "studentId": row.id,
        "teacherId": this.assignStudentsData.teacherId
      };
      this.delete(this.$url.deleteTeacherStudentLink, data).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.$emit('refresh', this.assignStudentsData);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    search(query) {
      this.studentName = query;
      this.$emit('search', this.studentName);
    },
    handleAddSelection(addedItems) {
      if (!addedItems.length) return;
      // 调用新增选中项的接口
      this.post(this.$url.insertTeacherStudentLink, {
        "studentId": addedItems[0].id || '',
        "teacherId": this.assignStudentsData.teacherId
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.$emit('refresh', this.assignStudentsData);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 关闭弹出窗口
    dialogClose() {
      this.refresh();
      this.$emit("update:assignStudentsDialogShow", false);
    },
    dialogOpen() { },
  },
};
</script>

<style lang="scss" scoped>
@import "./assignStudentsDialog.scss";
</style>
